import React from 'react';
import { dropdown_options, dropdown, flag } from '../partnerStyles';
import allCountriesData from '../utils/country-code-mapping';
import view from '../Enums';

const DropdownMenuMobile = props => {
  const options = Object.keys(allCountriesData).map(x => {
    if (x === 'UK') return null;
    return (
      <div
        id={props.id ? props.id : String(Math.random())}
        className="s"
        onClick={() => {
          props.k(x);
        }}
        style={{ ...dropdown_options, display: 'flex' }}
      >
        <span
          style={{
            ...flag,
            backgroundPosition: '0 -' + (allCountriesData[x][1] - 1) * 16 + 'px',
            left: 0,
            top: props.topPos
          }}
        />
        <span style={{ marginLeft: '0%' }}>{allCountriesData[x][0]}</span>
        <span style={{ marginLeft: '2%' }}>{allCountriesData[x][2]}</span>
      </div>
    );
  });

  return (
    <div
      style={
        props.viewSize === 'Desktop' || props.viewMode === view.DESKTOP
          ? { ...dropdown, width: props.divWidth, top: props.divTop }
          : { ...dropdown, width: '100%', position: 'relative' }
      }
    >
      <span>{options}</span>
    </div>
  );
};

export default DropdownMenuMobile;
